// src/utils/storageUtils.ts

/**
 * Utility functions for local storage operations with error handling
 */

export const saveToStorage = (key: string, value: any): void => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error(`Error saving to storage [${key}]:`, error);
    }
};

export function getFromStorage<T>(key: string, defaultValue: T | null = null): T | null {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
        console.error(`Error reading from storage [${key}]:`, error);
        return defaultValue;
    }
}

export const removeFromStorage = (key: string): void => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error(`Error removing from storage [${key}]:`, error);
    }
};
